// resourceHome — where opening a resource lands: the ONE routing rule behind
// `openRef` (library rows, Home/Journal, the omnibar, create/duplicate/ingest
// landings, review links, "Go to change"). Pure and total.
//
//   source   → its viewer in the Knowledge bank (#59: the Library holds
//              only learning materials);
//   file     → the Knowledge bank too (an upload not yet made a source);
//   material → its library detail, edited in place (the material editor tab
//              is retired, library layout 2026-10-01) — the main view, with
//              the chat docked beside it (redesign step 1);
//   package  → its resource tab (ExportView).
//
// `target` (WHERE in it: a page, an element) rides along to the landing.

import type {
    FocusTarget,
    ResourceRef,
} from "../../components/Navigation/types.js";
import type { SearchResultKind } from "../../components/Search/searchModel.js";
import type { FrameTransition } from "../frame.js";

// Which list a kind lives in (#59): the Library holds what is made in the app
// (materials and their packages); the Knowledge bank what it is made FROM
// (sources, and raw files not yet made sources). Conversations live in the
// chat. Every other kind is in exactly one of the two.
export const LIBRARY_KINDS: readonly SearchResultKind[] = [
    "material",
    "package",
];
export const KNOWLEDGE_KINDS: readonly SearchResultKind[] = ["source", "file"];

export const openResourceTransition = (
    ref: ResourceRef,
    target?: FocusTarget,
): FrameTransition => {
    switch (ref.type) {
        case "source":
        case "file":
            return { type: "open-knowledge", selectedId: ref.id, target };
        case "material":
            return {
                type: "open-search",
                kind: "material",
                selectedId: ref.id,
                target,
            };
        case "export":
            return { type: "open-resource", ref, target };
    }
};
